import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../Input';
import TranslatedFieldsRow from '../../modules/TranslationsFieldsRow';
import RemoveIcon from '../../assets/icons/close.svg';
import Button from '../Button';
import { hasMaxLength, isNotEmpty } from '../../hooks/formValidator/validators';
import { updateInputTaskAnswerTranslation } from '../../forms/AdminContentForms/adminTask/ValidatedInputTask/helpers';
const AdminInputTaskAnswerCard = forwardRef(({ inputTaskAnswer, inputTaskIndex, formState, formErrors, validateInputField, setUpdatedFormFields, onDeleteInputTaskAnswer, }, ref) => {
    const { t, i18n } = useTranslation();
    const onAnswerTranslationsChange = (lang, value) => {
        updateInputTaskAnswerTranslation({
            formState,
            id: inputTaskAnswer.clientId,
            lang,
            value,
        });
        validateInputField({
            fieldName: `inputAnswer${inputTaskIndex + 1}${lang.toUpperCase()}`,
            value,
            customInputSchema: {
                [`inputAnswer${inputTaskIndex + 1}${lang.toUpperCase()}`]: [isNotEmpty, hasMaxLength(64)],
            },
        });
        setUpdatedFormFields((prev) => {
            const newSet = new Set(prev);
            newSet.add('inputTaskAnswers');
            return newSet;
        });
    };
    return (_jsxs("div", { className: "task-answer-item input-task", ref: ref, children: [_jsxs("div", { className: "task-answer-item-header", children: [_jsx("div", { className: "task-answer-order-controls", children: _jsx("div", { className: "task-answer-order", children: _jsx("span", { children: inputTaskIndex + 1 }) }) }), _jsx(Input, { color: 'gray', id: `input-answer-${inputTaskIndex + 1}`, value: inputTaskAnswer.translations[i18n.language], name: `inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`, placeholder: `${t('placeholder.answer')} ${inputTaskIndex + 1}`, onChange: (event) => {
                            updateInputTaskAnswerTranslation({
                                formState,
                                id: inputTaskAnswer.clientId,
                                lang: i18n.language,
                                value: event.currentTarget.value,
                            });
                            validateInputField({
                                fieldName: `inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`,
                                value: event.currentTarget.value,
                                customInputSchema: {
                                    [`inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`]: [
                                        isNotEmpty,
                                        hasMaxLength(64),
                                    ],
                                },
                            });
                            setUpdatedFormFields((prev) => {
                                const newSet = new Set(prev);
                                newSet.add('inputTaskAnswers');
                                return newSet;
                            });
                        }, additionalContent: _jsx(Button, { shape: 'square', icon: _jsx(RemoveIcon, {}), iconSize: 'small', onClick: () => onDeleteInputTaskAnswer(inputTaskAnswer.clientId), disabled: formState.inputTaskAnswers.length === 1 }), error: !!formErrors[`inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`]?.length, errorMessage: formErrors[`inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`]?.length
                            ? t(formErrors[`inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`][0]
                                .messageTranslationKey, formErrors[`inputAnswer${inputTaskIndex + 1}${i18n.language.toUpperCase()}`][0]
                                .variableToUseInMessage)
                            : undefined })] }), _jsx("div", { className: "form-translations-group", children: _jsx(TranslatedFieldsRow, { fieldName: `inputAnswer${inputTaskIndex + 1}`, values: inputTaskAnswer.translations, onChange: (lang, value) => onAnswerTranslationsChange(lang, value), formErrors: formErrors, originContent: inputTaskAnswer.translations[i18n.language], placeholder: `${t('placeholder.answer')} ${inputTaskIndex + 1}` }) })] }));
});
export default AdminInputTaskAnswerCard;
